import { useEffect, useRef } from "react";

const ScrollVideoBackground = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    let raf;
    let current = 0;
    const FRAME = 1 / 30;
    const tick = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const progress = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      if (v.duration && !Number.isNaN(v.duration) && v.readyState >= 2) {
        const target = progress * (v.duration - 0.05);
        current += (target - current) * 0.18;
        if (Math.abs(current - v.currentTime) >= FRAME) {
          if (typeof v.fastSeek === "function") v.fastSeek(current);
          else v.currentTime = current;
        }
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="fixed inset-0 z-0 pointer-events-none" data-testid="scroll-video-bg">
      <video
        ref={videoRef}
        src="/bg-scroll.mp4"
        className="w-full h-full object-cover"
        muted
        playsInline
        preload="auto"
      />
      <div className="absolute inset-0 bg-canvas/65" />
    </div>
  );
};

export default ScrollVideoBackground;
